import { render, staticRenderFns } from "./ErrorsPanel.vue?vue&type=template&id=34955696&scoped=true&"
import script from "./ErrorsPanel.vue?vue&type=script&lang=ts&"
export * from "./ErrorsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorsPanel.vue?vue&type=style&index=0&id=34955696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34955696",
  null
  
)

export default component.exports